import React, { forwardRef } from 'react';
import Type from 'prop-types';

const ExternalLink = forwardRef((props, ref) => {
  const { to, children, ...other } = props;

  return (
    <a href={to} target="_blank" rel="noopener noreferrer" {...other} ref={ref}>
      {children}
    </a>
  );
});

ExternalLink.propTypes = {
  to: Type.oneOfType([Type.string, Type.object, Type.func]).isRequired,
  children: Type.node.isRequired,
};

export default ExternalLink;
